<template>
<div>
    <title>额度管理</title>
    <section class="mainPart">
        <!--S 公用头部切换-->
        <CompanyTabJsz :active="currentTit" :flowcode="flowcode" :forbid='true'></CompanyTabJsz>
        <!--E 公用头部切换-->
        <div class="pt64" >
            <!-- 未开通额度时只有此按钮 -->
            <p class="mtb20" v-show="sellType==1&&details==''">
                <el-popover placement="bottom-start" width="400" trigger="click" @show="getShowAdd">
                    <el-form class="settleForm" :model="settleForm" label-width="80px">
                        <el-form-item label="授信额度" class="mb0">
                            <el-input v-model="settleForm.quota"  @input="quotas" maxlength="9" clearable>
                                <i slot="prepend">￥</i>
                            </el-input>
                            <p class="greyColor">
                              剩余可分配额度：<span class="priceFont redColor"><i>￥</i>{{detailsmd.surplusquota|formatAmount}}</span>
                            </p>
                        </el-form-item>
                        
                        <el-form-item label="备注">
                            <el-input type="textarea" maxlength="50" placeholder="填写备注" v-model="settleForm.memo"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="center">
                        <el-button type="primary" size="mini" :loading="showKted" @click="openDisquota">确定</el-button>
                        <el-button size="mini" @click="getClosePop">取消</el-button>
                    </div>
                    <el-button type="primary" slot="reference" v-show="sellType==1&&details==''">开通额度</el-button>
                </el-popover>
            </p>
            <!-- 未开通额度时只有此按钮 -->

            <!-- S 额度信息展示形式块级- 只有门店下的分销商是块级形式，其他都为简版形式 -->
            <div class="edInfo" v-if="sellType==0">
                <ul>
                    <li>
                        <span class="flexUpDownCenter bgSpan">
                            <b>门店总授信额度(￥)</b>
                            <strong>{{details.quota |formatAmount}}</strong>
                        </span>
                        <span class="flexUpDownCenter">
                            <b>已使用额度(￥)</b>
                            <strong>
                              {{(Number(details.quota||0) - Number(details.totalsurplusquota||0))|formatAmount}} </strong>
                        </span>
                        <span class="flexUpDownCenter">
                            <b>剩余额度(￥)</b>
                            <strong>{{details.totalsurplusquota |formatAmount}}</strong>
                        </span>
                    </li>
                    <li>
                        <span class="flexUpDownCenter borderSpan">
                            <b>划分门店额度(￥)</b>
                            <strong>{{(Number(details.quota||0) -Number(detailsTotal.dtquota ||0))|formatAmount}}</strong>
                        </span>
                        <span class="flexUpDownCenter">
                            <b>已使用额度(￥)</b>
                            <strong>{{details.usedquota|formatAmount}}</strong>
                        </span>
                        <span class="flexUpDownCenter">
                            <b>剩余额度(￥)</b>
                            <strong>{{details.surplusquota|formatAmount}}</strong>
                        </span>
                    </li>
                    <li>
                        <span class="flexUpDownCenter borderSpan">
                            <b>划分分销商额度(￥)</b>
                            <strong>{{detailsTotal.dtquota|formatAmount}}</strong>
                        </span>
                        <span class="flexUpDownCenter">
                            <b>已使用额度(￥)</b>
                            <strong>{{detailsTotal.dusedquota|formatAmount}}</strong>
                        </span>
                        <span class="flexUpDownCenter">
                            <b>剩余额度(￥)</b>
                            <strong>{{detailsTotal.dcurcanusequota|formatAmount}}</strong>
                        </span>
                        <div class="edtz" @click="adjustDlog=true">调整额度></div>
                    </li>
                    
                </ul>
            </div>
            <!-- E 额度信息展示形式块级- 只有门店下的分销商是块级形式，其他都为简版形式 -->
            <!-- S 额度信息展示形式简版- 只有门店下的分销商是块级形式，其他都为简版形式-->
            <div class="flexUpDownCenter" v-if="sellType==1&&details!=''">
                <ul class="quotaWrap">
                    <li>
                        <em>授信额度(￥)</em>
                        <strong class="priceFont blueColor">{{details.curcanusequota |formatAmount}}</strong>
                    </li>
                    <li>
                        <em>已使用额度(￥)</em>
                        <strong class="priceFont orangeColor">{{details.usedquota|formatAmount}}</strong>
                    </li>
                    <li>
                        <em>剩余额度(￥)</em>
                        <strong class="priceFont redColor">{{details.surplusquota|formatAmount}}</strong>
                    </li>
                </ul>
                <el-popover placement="bottom-start" width="400" trigger="click" @show="getShowAdd">
                    <el-form class="settleForm" :model="addRedForm" label-width="80px">
                        <el-form-item label="调整额度">
                          <el-radio-group v-model="addRedForm.quotatype">
                            <el-radio label="0">增加</el-radio>
                            <el-radio label="1">减少</el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <el-form-item label="调整额度" class="pt20">
                            <el-input v-model="addRedForm.amount"  @input="quotas" maxlength="9" clearable>
                                <i slot="prepend">￥</i>
                            </el-input>
                            <p class="greyColor">
                              剩余可分配额度：<span class="priceFont redColor"><i>￥</i>{{detailsmd.surplusquota|formatAmount}}</span>
                            </p>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input type="textarea" maxlength="50" placeholder="填写备注" v-model="addRedForm.memo"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="center">
                        <el-button type="primary" size="mini" :loading="showTzed"  @click="addAndtel">确定</el-button>
                        <el-button size="mini" @click="getClosePop">取消</el-button>
                    </div>
                    <el-button type="primary" slot="reference">额度调整</el-button>
                </el-popover>
            </div>
            <!-- S 额度信息展示形式简版- 只有门店下的分销商是块级形式，其他都为简版形式 -->
            
        </div>
        <!-- 检索条件 s -->
        <el-form :inline="true" class="demo-form-inline xForm" v-show="details!=''">
            <el-form-item label="操作时间：" class="xDateFm">
                <!-- S 双日期选择器 -->
                <TwoDatePicker :noQuick="1" @twoDateObtain="twoDateReceive" :startvaldate="startvaldate" :endvaldate="endvaldate"></TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item label="记录类型：">
                <el-select v-model="type" placeholder="请选择" clearable  class="xSelect">
                    <el-option label="提升额度" value="0"></el-option>
                    <el-option label="降低额度" value="1"></el-option>
                    <el-option label="账单还款" value="2"></el-option>
                    <el-option label="账单退款" value="3"></el-option>
                    <el-option label="交易扣除" value="4"></el-option>
                    <el-option label="交易退款" value="5"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" class="xSearch" @click="quotaSearch">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- 检索条件 e -->
        <!--table表格 s-->
        <el-table v-show="details!=''"  v-loading="loading" :data="storedisquotachangeList" class="comTable" border ref="gsTable" :maxHeight="sellType==0?'680px':tableHeight">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="销售单号" sortable prop="saleorderno" min-width="120">
                <template slot-scope="scope">
                    <p class="textFl" :title="scope.row.saleorderno">{{scope.row.saleorderno ||'--'}}</p>
                </template>
            </el-table-column>
            <el-table-column label="额度变更（￥）" sortable prop="amount" min-width="100">
                <template slot-scope="scope">
                    <!-- 提升额度、交易退款类型前面有加号 -->
                    <p v-if="scope.row.type == 1 || scope.row.type == 4" class="textFl commonNum redColor" :title="'- ' + scope.row.amount">
                        -{{scope.row.amount|formatAmount}}
                    </p>
                    <p v-else class="textFl commonNum  greenColor" :title="'+ ' + scope.row.amount">
                        +{{scope.row.amount|formatAmount}}
                    </p>
                    <small class="textFl greyColor" :title="scope.row.credate">{{scope.row.credate}}</small>
                </template>
            </el-table-column>
            <el-table-column label="账单来源" sortable prop="flowname" min-width="100">
                <template slot-scope="scope">
                    <p>{{scope.row.flowname}}</p>
                </template>
            </el-table-column>
            <el-table-column label="操作时间" sortable prop="changedate" min-width="100">
                <template slot-scope="scope">
                    <p>{{dateTime(scope.row.changedate,1)}}</p>
                </template>
            </el-table-column>           
             <el-table-column label="记录类型" sortable prop="type" min-width="100">
                <template slot-scope="scope">
                    <p :title="scope.row.type" :class="[{'greenColor':scope.row.type == 0},{'orangeColor':scope.row.type == 1},{'greyColor':scope.row.type == 2},{'blueColor':scope.row.type == 3},{'redColor':scope.row.type == 4}]">{{scope.row.type | typeFilters}}</p>
                </template>
            </el-table-column>
            <!-- <el-table-column label="操作人" min-width="100">
                <template slot-scope="scope">
                <p class="textFl" :title="scope.row.operuname">{{scope.row.operuname ||'--'}}</p>
                </template>
            </el-table-column> -->
            <el-table-column label="备注" min-width="150">
                <template slot-scope="scope">
                <p class="textFl" :title="scope.row.memo">{{scope.row.memo||'--'}}</p>
                </template>
            </el-table-column>
            <template slot="empty">
                <div class="noData"><span>暂无数据</span></div>
            </template>	
        </el-table>
        <!--table表格 e-->
        <!-- S 分页 -->
        <Page v-if="details!=''" :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
        <!-- E 分页 -->
        <!-- 额度调整弹出框 s -->
        <el-dialog class="comDlog adjustDlog" title="额度调整" :visible.sync="adjustDlog" :modal-append-to-body="false" append-to-body :close-on-click-modal="false">
            <el-form :model="transferForm" inline>
                <el-form-item label="分销商">
                    <el-input  clearable v-model="flowname" placeholder="请输入分销商名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="xSearch" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="flowList"  v-loading="loadings" border class="comTable noBottomTable" maxHeight="450">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column  label="分销商" min-width="150" prop="flowname" sortable>
                    <template slot-scope="scope">
                        <p class="textFl pr70" :title="scope.row.flowname">{{scope.row.flowname||'--'}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="授信额度(￥)" prop="quota" sortable min-width="180">
                    <template slot-scope="scope">
                        <em class="priceFont">{{scope.row.curcanusequota |formatAmount}}</em>
                    </template>
                </el-table-column>
                <el-table-column label="剩余/已使用额度(￥)" prop="surplusquota" sortable min-width="200">
                    <template slot-scope="scope">
                        <p>
                            <em class="priceFont greenColor">{{scope.row.surplusquota|formatAmount}}</em>
                            /
                            <em class="priceFont greyColor">{{scope.row.usedquota|formatAmount}}</em>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="130">
                    <template slot-scope="scope">
                        <el-popover v-show="scope.row.curcanusequota"  placement="bottom" width="450" trigger="click" :value="addRedVisible&&scope.$index==pop1" @show="mallShowPop1(scope.$index)" @hide="mallClosePop1(scope.$index)">
                            <el-form :model="addRedForm" class="setForm" label-width="90px">
                                <el-form-item class="addItem" label="调整金额">
                                    <el-input v-model="addRedForm.amount" clearable  @input="amounts"  maxlength="9">
                                    <template slot="prepend">￥</template>
                                    </el-input>
                                    <p class="greyColor">剩余可分配额度<b class="priceFont redColor"><i>￥</i>{{details.surplusquota||'0.00'}}</b></p>
                                </el-form-item>
                                <el-form-item label="备注">
                                    <el-input type="textarea" v-model="addRedForm.memo" maxlength="50" clearable placeholder="填写备注"></el-input>
                                </el-form-item> 
                            </el-form>
                            <div class="center">
                                <el-button type="primary" size="mini" :loading="showEd" @click="getSubmitRed(scope.row,0)">确定</el-button>
                                <el-button size="mini" @click="getClosePop()">取消</el-button>
                            </div>
                            <span  class="el-icon-circle-plus-outline setSpan" title="增加额度"  slot="reference"></span>
                        </el-popover>
                        
                        <el-popover  v-show="scope.row.curcanusequota" placement="bottom" width="450" trigger="click" :value="reduceRedVisible&&scope.$index==pop2" @show="mallShowPop2(scope.$index)" @hide="mallClosePop2(scope.$index)">
                            <el-form :model="addRedForm" class="setForm" label-width="90px">
                                <el-form-item class="addItem" label="调整金额">
                                        <el-input v-model="addRedForm.amount" clearable  @input="amounts"  maxlength="9">
                                            <template slot="prepend">￥</template>
                                        </el-input>
                                        <p class="greyColor">&nbsp;</p>
                                        <!--剩余可分配额度<b class="priceFont redColor"><i>￥</i>{{details.surplusquota||'0.00'}}</b>-->
                                </el-form-item>
                                <el-form-item label="备注">
                                    <el-input type="textarea" v-model="addRedForm.memo" maxlength="50" clearable placeholder="填写备注"></el-input>
                                </el-form-item> 
                            </el-form>
                            <div class="center">
                                <el-button type="primary" size="mini" :loading="showEd" @click="getSubmitRed(scope.row,1)">确定</el-button>
                                <el-button size="mini" @click="getClosePop()">取消</el-button>
                            </div>
                            <span  class="el-icon-remove-outline setSpan" title="减少额度"  slot="reference"></span>
                        </el-popover>

                        <el-popover   placement="bottom" width="450" trigger="click" :value="FxsEd&&scope.$index==pop3" @show="mallEdshow(scope.$index)" @hide="mallEdhide(scope.$index)">
                            <el-form class="settleForm" :model="settleForm" label-width="80px">
                                <el-form-item label="授信额度" class="pt20 mb0">
                                    <el-input v-model="settleForm.quota"  @input="quotas" maxlength="9" clearable>
                                        <i slot="prepend">￥</i>
                                    </el-input>
                                    <p class="greyColor">
                                      剩余可分配额度：<span class="priceFont redColor"><i>￥</i>{{detailsmd.surplusquota|formatAmount}}</span>
                                    </p>
                                </el-form-item>
                                
                                <el-form-item label="备注">
                                    <el-input type="textarea" maxlength="50" placeholder="填写备注" v-model="settleForm.memo"></el-input>
                                </el-form-item>
                            </el-form>
                            <div class="center">
                                <el-button type="primary" size="mini" :loading="showKted" @click="openDisquotas(scope.row.flowcode)">确定</el-button>
                                <el-button size="mini" @click="getClosePop">取消</el-button>
                            </div>
                            <span class="blueColor" title="开通额度" v-show="!scope.row.curcanusequota" slot="reference">开通额度</span>
                        </el-popover>
                    </template>
                </el-table-column>
                <template slot="empty">
                    <div class="noData"><span>暂无数据</span></div>
                </template>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="adjustDlog=false;getStoredisquotachangeList();getStoredisquotaTotal();getStoredisquota()">关闭</el-button>
                <!-- <el-button >取消</el-button> -->
            </span>
        </el-dialog>
		<!-- 额度调整弹出框 e -->

        
        
       
    </section>
</div>
</template>
<script>
import echarts from "echarts";
import Vue from "vue";
import Api from '@/apis/api';
export default {
    name:'Information',
    data(){
        return{
            FxsEd:false,
            detailsmd:'',
            loadings:false,
            loading:false,
            showEd:false,
            showTzed:false,
            showKted:false,
            pop1:-1,
            pop2:-1,
            pop3:-1,
            pageTotal:0, //总数
            currentPage:1, // 页数
            pageSize:30, // 条数
            startvaldate:'',
            endvaldate:'',
            type:'',
            flowname:'',
            flowcode:'',
            details:'',
            detailsTotal:'',
            addRedVisible:false,
            reduceRedVisible:false,
            sellType:this.$route.params.sellType,//销售类型：0：自己；1：有二级分销商
            currentTit:1,//选中的tab
            adjustDlog:false,//调整额度的弹框
            transferForm:{//分销商查询
                goodsname:''
            },
            flowList:[//分销商列表
            ],
            addRedForm:{ //增减库存
                quotatype:'0',
                amount:'',
                memo:''
            },
            settleForm:{
                memo:'',
                quota:'',
            },
            settleVisible:false,//开通额度弹窗
            settleVisibles:false,//开通额度弹窗
            formLabelWidth:"110px",//自定义表单左侧尺寸
            //额度管理表格
            storedisquotachangeList: [],
            applyVisible: false, //额度申请调整弹出框，默认不显示
            tableHeight: window.innerHeight*.8, //表格动态高度
        }
    },
    //================================================ 组件 ================================================
    components: {
        CompanyTabJsz: resolve => require(["@/components/ManageFolder/CompanyTabJsz.vue"],resolve), //头部tab组件
        Page: resolve => require(["@/components/common/Page.vue"], resolve),
        TwoDatePicker: resolve =>require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
    },
    watch: {
      'settleVisible':function(val){
          if(!val){
              this.settleForm={
                memo:'',
                quota:'',
            }
          }
      },
      'reduceRedVisible':function(val){
          if(!val){
               this.addRedForm={ //增减库存
                quotatype:'0',
                amount:'',
                memo:''
            }
          }
      },
      'settleVisibles':function(val){
         if(!val){
               this.addRedForm={ //增减库存
                quotatype:'0',
                amount:'',
                memo:''
            }
          }
      },
      'adjustDlog':function(val){
        if(val){
          this.flowname = '';
          this.getflowList()
        }
      },
      $route() {
          this.sellType=this.$route.params.sellType;//接受路由带过来的变量，控制元素显隐
      },
    },
    //================================================ 方法 ================================================
    methods: {
        // 选择的日期
        twoDateReceive(val) {
          if(val){
            this.startvaldate = this.dateTime(val[0]);
            this.endvaldate = this.dateTime(val[1]);
          }else{
            this.startvaldate = '';
            this.endvaldate = '';
          }
        },
        //动态获取表格高度
        getHeight() {
          if(this.$refs.gsTable){
              let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            this.tableHeight = window.innerHeight - tbHeight - 110; 
           }  
        },
        amounts(){
            this.addRedForm.amount= this.amountChech(this.addRedForm.amount);
        },
        quotas(){
            this.settleForm.quota = this.amountChech(this.settleForm.quota);
        },
        // 打开调整额度气泡
        getShowAdd(){
            this.settleForm={
                memo:'',
                quota:'',
            }
            this.addRedForm={ //增减库存
                quotatype:'0',
                amount:'',
                memo:''
            }
        },
        addAndtel(){
          this.showTzed = true;
           let reg = (/^(([1-9]\d*)|\d)(\.\d{1,2})?$/);
          if(!reg.test(this.addRedForm.amount)){
            this.$message.error('请输入正确的金额！');
            this.showTzed = false;
            return
          }
          if(Number(this.detailsmd.surplusquota)<Number(this.addRedForm.amount)){
              this.$message.error('剩余可分配额度不足！');
              this.showTzed = false;
              return
          }
          if(this.addRedForm.amount>0){
                   let param ={
                     flowcode:this.flowcode,
                     type:Number(this.addRedForm.quotatype),
                     quota:this.addRedForm.amount,
                     memo:this.addRedForm.memo,
                     }
                   Api.UPDATESTOREDISQUOTA(param).then(res =>{
                     if(res.data.status=="200"){
                      //  this.getflowList();
                       this.showTzed = false;
                       this.getStoredisquotamd();
                       this.getStoredisquota();
                       this.getStoredisquotachangeList();
                       document.querySelector("#app").click(); //为了点击空白处关闭弹框
                       this.$message({
                          message: res.data.message,
                          type: 'success'
                        });
                     }else{
                       this.showTzed = false;
                       this.$message.error(res.data.message)
                     }
                   })
            }else{
                 this.showTzed = false;
                 this.$message.error('请输入有效金额！');
            }
        },
        // 提交库存
        getSubmitRed(row,type){
           this.showEd = true;
           let reg = (/^(([1-9]\d*)|\d)(\.\d{1,2})?$/);
          if(!reg.test(this.addRedForm.amount)){
            this.$message.error('请输入正确的金额！');
            this.showEd = false;
            return
          }
            if(this.addRedForm.amount>0){
                   let param ={
                     flowcode:row.flowcode,
                     type:Number(type),
                     quota:this.addRedForm.amount,
                     memo:this.addRedForm.memo,
                     }
                   Api.UPDATESTOREDISQUOTA(param).then(res =>{
                     if(res.data.status=="200"){
                       this.showEd = false;
                       this.getStoredisquota();
                       this.getflowList();
                       document.querySelector("#app").click(); //为了点击空白处关闭弹框
                       this.$message({
                          message: res.data.message,
                          type: 'success'
                        });
                     }else{
                       this.showEd = false;
                       this.$message.error(res.data.message)
                     }
                   })
            }else{
                this.showEd = false;
                 this.$message.error('请输入有效金额！');
            }
        },
        // 关闭表格的pop弹出框
        getClosePop(row){
            this.addRedVisible = false;
            this.reduceRedVisible = false
            this.FxsEd = false;
            document.querySelector("#app").click(); //为了点击空白处关闭弹框
        },
        // 打开poper上限时触发的方法
        mallShowPop1(index){
            this.pop1 = index;
            this.addRedForm.amount = '';
            this.addRedForm.memo = '';
           this.addRedVisible=true;
           this.getStoredisquotamd();
        },
        mallShowPop2(index){
           this.pop2 = index;
            this.addRedForm.amount = '';
            this.addRedForm.memo = '';
            this.reduceRedVisible=true;
            this.getStoredisquotamd();
        },
        mallEdhide(index){
          this.pop3 = -1;
          this.FxsEd = false;
        },
        mallEdshow(index){
          this.pop3 = index;
          this.FxsEd = true;
          this.settleForm={
                memo:'',
                quota:'',
            }
          this.getStoredisquotamd();
        },
        // 关闭poper上限时触发的方法
        mallClosePop1(index){
             this.pop1 = -1;
             this.addRedVisible=false;
        },
        mallClosePop2(index){
          this.pop2 = -1;
           this.reduceRedVisible=false;
        },
        search(){
          this.getflowList();
        },
        getflowList(){
          this.loadings = true;
          let param ={
            flowname:this.flowname,
            status:1,
            objtype:7,
            isopensale:1
          }
          Api.GET_FLOWLIST(param).then(res =>{
             if(res.data.status=="200"&&res.data.data){
                 this.loadings = false;
                 this.flowList = res.data.data;
                 this.flowList.map((item,index) =>{
                  Api.GET_STOREDISQUOTA({flowcode:item.flowcode}).then(res =>{
                        if(res.data.status=="200"&&res.data.data!=null){
                          let list = res.data.data;
                          Vue.set(this.flowList[index],'curcanusequota',list.curcanusequota)
                          Vue.set(this.flowList[index],'usedquota',list.usedquota)
                          Vue.set(this.flowList[index],'surplusquota',list.surplusquota)
                        }
                      })
                 })
             }else{
                 this.loadings = false;
                 this.flowList = [];
             }
          })
        },
        //额度详情
        getStoredisquota(){
          Api.GET_STOREDISQUOTA({flowcode:this.flowcode}).then(res =>{
            if(res.data.status=="200"&&res.data.data!=null){
               this.details = res.data.data;
            }else{
               this.details = '';
            }
          })
        },
        //额度详情门店
        getStoredisquotamd(){
          if(localStorage.getItem('userInfoMd')){
                let userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
                let flowcode = userInfoMd.flowcode;
                Api.GET_STOREDISQUOTA({flowcode:flowcode}).then(res =>{
                  if(res.data.status=="200"&&res.data.data!=null){
                    this.detailsmd = res.data.data;
                  }else{
                    this.detailsmd = '';
                  }
                })
              }
        },
        //门店额度汇总详情（只统计分销商的）
        getStoredisquotaTotal(){
           Api.GET_STOREDISQUOTATOTAL({}).then(res =>{
              if(res.data.status=="200"&&res.data.data!=null){
               this.detailsTotal = res.data.data;
              }else{
                this.detailsTotal = '';
              }
          })
        },
        quotaSearch(){
          this.currentPage =1,
          this.getStoredisquotachangeList();
        },
        nowPageParam(val,vals){
          this.pageSize = val;
          this.currentPage = vals;
          this.getStoredisquotachangeList();
        },
        //额度变更记录列表
        getStoredisquotachangeList(){
          this.loading = true;
          let param = {
               flowcode:this.flowcode,
               type:this.type,
               startvaldate:this.startvaldate,
               endvaldate:this.endvaldate,
               pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
              }
          }
          Api.GET_STROEDISQUOTACHANGELIST(param).then(res =>{
               if(res.data.status=="200"){
                 this.loading = false;
                 this.storedisquotachangeList = res.data.data;
                 this.pageTotal = res.data.pagebean.totalnum;
                 this.$refs.gsTable.bodyWrapper.scrollTop = 0;
              }else {
                 this.loading = false;
                 this.pageTotal =0;
                 this.storedisquotachangeList =[];
              }
          })
        },
        openDisquotas(flowcode){
           this.showKted = true;
          let reg = (/^(([1-9]\d*)|\d)(\.\d{1,2})?$/);
          if(!reg.test(this.settleForm.quota)){
            this.$message.error('请输入正确的金额！');
            this.showKted = false;
            return
          }
          if(this.detailsmd.surplusquota==null||this.detailsmd.surplusquota==''||this.detailsmd.surplusquota=='null'){
             this.$message.error('剩余可分配额度不足！');
             this.showKted = false;
              return
          }
          if(Number(this.detailsmd.surplusquota)<Number(this.settleForm.quota)){
              this.$message.error('剩余可分配额度不足！');
              this.showKted = false;
              return
          }
          Api.OPENDISQUOTA({flowcode:flowcode,memo:this.settleForm.memo,quota:this.settleForm.quota}).then(res =>{
             if(res.data.status=="200"){
               this.showKted = false;
                this.$message({
                message: res.data.message,
                type: 'success'
              });
               document.querySelector("#app").click(); //为了点击空白处关闭弹框
              this.getStoredisquota();
              this.getflowList();
              this.getStoredisquotachangeList();
             }else{
               this.showKted = false;
               this.$message.error(res.data.message);
             }
          })
        },
        //开通额度
        openDisquota(){
          this.showKted = true;
          let reg = (/^(([1-9]\d*)|\d)(\.\d{1,2})?$/);
          if(!reg.test(this.settleForm.quota)){
            this.$message.error('请输入正确的金额！');
            this.showKted = false;
            return
          }
          if(this.detailsmd.surplusquota==null||this.detailsmd.surplusquota==''||this.detailsmd.surplusquota=='null'){
             this.$message.error('剩余可分配额度不足！');
             this.showKted = false;
              return
          }
          if(Number(this.detailsmd.surplusquota)<Number(this.settleForm.quota)){
              this.$message.error('剩余可分配额度不足！');
              this.showKted = false;
              return
          }
          Api.OPENDISQUOTA({flowcode:this.flowcode,memo:this.settleForm.memo,quota:this.settleForm.quota}).then(res =>{
             if(res.data.status=="200"){
               this.showKted = false;
                this.$message({
                message: res.data.message,
                type: 'success'
              });
               document.querySelector("#app").click(); //为了点击空白处关闭弹框
              this.getStoredisquota();
              this.getStoredisquotamd();
              this.getStoredisquotachangeList();
             }else{
               this.showKted = false;
               this.$message.error(res.data.message);
             }
          })
        },
        test(){
             if (this.$route) {
                this.sellType=this.$route.params.sellType;//接受路由带过来的变量，控制元素显隐
              }
              if(this.sellType==0){// this.sellType==0
              if(localStorage.getItem('userInfoMd')){
                let userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
                this.flowcode = userInfoMd.flowcode;
              }
                this.getStoredisquota();
                this.getStoredisquotaTotal();
              }else{
                if(this.$route.params.flowcode){
                  this.flowcode = this.$route.params.flowcode;
                  this.getStoredisquotamd();
                  this.getStoredisquota();
                }
              }
              if(this.flowcode){
                this.getStoredisquotachangeList();
              }
        }
    },
    //================================================ 生命周期 ================================================
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },           
    beforeRouteUpdate(to, from, next) {
       next();
          if(localStorage.getItem('userInfoMd')){
                let userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
                this.flowcode = userInfoMd.flowcode;
                 this.getStoredisquota();
                this.getStoredisquotaTotal();
                this.getStoredisquotachangeList();
              }
      },
    mounted() {
        this.test();
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.mainPart{
    padding: 20px;
    height: calc(100% - 50px);
}

.adjQuota button {
  margin-top: 20px;
}
.xDateFm .el-date-editor .el-range__icon,
.xDateFm .el-date-editor .el-range-separator {
  line-height: 22px;
}
.xAdjust {
  width: 200px;
}

.quotaWrap{
    display:inline-block;
}
.quotaWrap li{
    margin-right:40px;
    display:inline-block;
    line-height:1.5;
}
.quotaWrap li em{
    display:block;
}
.quotaWrap li strong{
    font-size:20px;
}
.pt64 {padding-top: 64px; margin-bottom: 20px;}
.quotaWrap li strong i {color: inherit;}


.edInfo li {
    margin-bottom: 20px;
    box-shadow: 0px 0px 10px 0px rgba(28,36,49,0.08);
    width: 600px;
    min-height: 100px;
    overflow: hidden;
}
.edInfo li:last-child{width: 750px; position: relative;}
.edInfo li span {float: left; height: 80px; position: relative; margin: 10px 0; flex-direction: column; justify-content: center; width: 175px;}
.edInfo li span.bgSpan,.edInfo li span.borderSpan {width: 230px; padding-top: 18px;}
.edInfo li span b{line-height: 32px;}
.edInfo li span strong{line-height: 32px; font-weight: bold;}
.edInfo li span.bgSpan{background-color:var(--main-color);border:1px solid var(--main-color); color: #fff;}
.edInfo li span.borderSpan {background: #f7fbff;color: var(--main-color);border: 1px solid var(--main-color);}
.edInfo li span:nth-child(2){
    border-right: 1px dashed #e0e0e0;
}
.edInfo li span:nth-child(1) {
    margin: 0;
}
.edInfo li span:nth-child(1):after{
    position: absolute;
    z-index: 2;
    display: block;
    content: '';
    width: 0;
    height: 0;
    border-width: 10px;
    border-style: solid;
    border-color: #fff #fff transparent transparent;
    top: 50%;
    right: -12px;
    -webkit-transform: translateY(-50%)rotate(-135deg);
    transform: translateY(-50%)rotate(-135deg);
    box-shadow: 1px -1px 0px var(--main-color);
}
.edInfo li span:not(:first-child):hover strong{
    color: var(--main-color);
}

.edtz{
    display: block; position: absolute;
right: 10px; bottom: 20px; color: var(--main-color);
}
.edtz:hover {opacity: .7;cursor: pointer;}
/*增加库存*/
.cldTable {margin-top: 30px;}
.cldTable >>> tr td:last-child .cell{overflow: visible!important;}
.setForm >>> .el-form-item:first-child {margin-bottom:0;}
.setForm >>> .el-input {width: 100%; max-width: 340px;}
.setForm >>> textarea {max-width: 340px;}
.setSpan {font-size: 20px;padding: 0 5px;cursor: pointer;}
.setSpan:hover {color: var(--main-color);}
.center{text-align: center;}
.addItem >>> .el-input__inner {text-align: center;}
.addItem >>> .el-input-group__append{
    padding: 0 10px;
}
.adjustDlog >>> .el-dialog{width: 1200px;height: 600px;}
.pr70 {padding-right: 70px; width: auto;}
.settleForm >>> .el-form-item__content {
    width: 85%;
    min-width: 200px;
    max-width: 300px;
}
.settleForm >>> .mb0 {margin-bottom:0;}
.mtb20 {margin-bottom: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/ManageJsz/QuotaManage.vue